import { render, staticRenderFns } from "./EditEmailDialog.vue?vue&type=template&id=4a22527d&scoped=true&"
import script from "./EditEmailDialog.vue?vue&type=script&lang=js&"
export * from "./EditEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditEmailDialog.vue?vue&type=style&index=0&id=4a22527d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22527d",
  null
  
)

export default component.exports